import template from '../../templates/Home/header.template';
import Component from '../../core/component';

export default class Header extends Component {
  constructor(data) {
    super(template, data);
  }
}
